const React = require("react");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { useDropshippingResource } = require("../hooks/useDropshippingResource");
const { PageHeader, LinkButton, ResourceState, StatusBadge } = require("../components/ui");
const { filterVisiblePlatforms } = require("../platformVisibility");
const h = React.createElement;

const PLATFORM_DESTINATIONS = {
  "cj-dropshipping": { to: "/dropshipping/cj/signup", labelKey: "h_cj_configure", label: "Configure" },
  printful: { to: "/dropshipping/printful", labelKey: "h_pf_open", label: "Open Printful" },
  syncee: { to: "/dropshipping/syncee", labelKey: "h_syncee_open", label: "Open Syncee" },
  printify: { to: "/dropshipping/printify", labelKey: "h_printify_open", label: "Open Printify" },
  "inventory-source": { to: "/dropshipping/inventory-source", labelKey: "h_inventorySource_open", label: "Open Inventory Source" },
};

const DropshippingPlatforms = () => {
  const { api, t, isPlatformVisible } = useCJDropshipping();
  const resource = useDropshippingResource(() => api.listPlatforms(), [api]);
  const platforms = filterVisiblePlatforms(resource.data?.platforms, isPlatformVisible);
  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_cj_platforms_title", "Dropshipping platforms"),
      description: t("h_cj_platforms_desc", "Choose and configure a supplier platform for your Elakay shop."),
    }),
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: !platforms.length, onRetry: resource.reload, t },
      h("div", { className: "cjds-grid" }, ...platforms.map((platform) => h("article", { className: "cjds-card", key: platform._id },
        h("div", { className: "cjds-card-body" },
          h("div", { className: "cjds-row cjds-between" },
            h("h3", null, platform.name),
            h(StatusBadge, { status: platform.connection?.status || platform.status, t })
          ),
          h("p", { className: "cjds-muted" }, platform.websiteUrl),
          h("div", { className: "cjds-row" },
            h(LinkButton, { to: `/dropshipping/platforms/${platform._id}`, variant: "secondary" }, t("h_cj_details", "Details")),
            PLATFORM_DESTINATIONS[platform.slug]
              ? h(LinkButton, { to: PLATFORM_DESTINATIONS[platform.slug].to }, t(PLATFORM_DESTINATIONS[platform.slug].labelKey, PLATFORM_DESTINATIONS[platform.slug].label))
              : null
          )
        )
      )))
    )
  );
};

module.exports = { DropshippingPlatforms };
